const footer = document.querySelector('footer');
const header = document.querySelector('.header-wrapper');


function initScrollChecker() {
  let lastScrollPos = window.scrollY || window.pageYOffset;
  let ticking = false;

  const update = () => {
    const scrollPos = window.scrollY || window.pageYOffset;

    if (scrollPos > lastScrollPos) {
      document.body.classList.add("scroll-down");
      document.body.classList.remove("scroll-up");
    } else {
      document.body.classList.add("scroll-up");
      document.body.classList.remove("scroll-down");
    }

    document.body.classList.toggle("is-scrolled", scrollPos > 0);
    document.body.classList.toggle("hide", scrollPos > 250);

    lastScrollPos = scrollPos;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  update();
}




function setHeaderFooterHeight() {
  setTimeout(function () {
    document.documentElement.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }, 200)
}

window.addEventListener('resize', setHeaderFooterHeight);

export function updateGeolocation(country, lang) {
  console.log(`[geo] Updating geolocation to country: ${country}, language: ${lang}`);
  const formId = crypto.randomUUID();
  const formHtml = `
                <form id="${formId}" action="/localization" method="POST" hidden>
                    <input name="_method" value="PUT">
                    <input name="country_code" value="${country}">
                    <input name="language_code" value="${lang}">
                    <input name="return_to" value="${window.location.pathname}">
                </form>
                `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  document.getElementById(formId).submit();
}

// Espone la funzione globalmente per renderla richiamabile da attributi onclick
window.updateGeolocation = updateGeolocation;

// selectors can be:
// - string (same selector for source and target)
// - { source: string, target: string }
export async function updateDomComponent(
  selectors,
  sections,
  currentUrl = window.location.pathname,
  options = {},
) {

  console.log(selectors, sections, currentUrl, options);

  try {
    if (!Array.isArray(selectors) || !Array.isArray(sections)) {
      throw new Error("selectors and sections must be arrays");
    }

    if (selectors.length === 0 || sections.length === 0) {
      throw new Error("selectors and sections cannot be empty");
    }

    if (selectors.length !== sections.length) {
      throw new Error("selectors and sections must have the same length");
    }

    // Usa sempre le sezioni richieste
    const url = new URL(currentUrl, window.location.origin);
    url.searchParams.set("sections", sections.join(","));

    const response = await fetch(url.toString());

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const parser = new DOMParser();

    // Aggiorna ogni selettore con la sezione corrispondente
    const documents = [];
    const mode = options.mode === "replace" ? "replace" : "innerHTML";

    selectors.forEach((entry, index) => {
      const sectionId = sections[index];
      const sourceSelector = typeof entry === "string" ? entry : entry.source;
      const targetSelector = typeof entry === "string" ? entry : entry.target;

      const targetElement = document.querySelector(targetSelector);

      if (targetElement && data[sectionId]) {
        const doc = parser.parseFromString(data[sectionId], "text/html");
        const sourceNode = doc.querySelector(sourceSelector);

        if (sourceNode) {
          if (mode === "replace") {
            targetElement.replaceWith(sourceNode);
          } else {
            targetElement.innerHTML = sourceNode.innerHTML;
          }
        }

        if (options.returnDocument) {
          documents[index] = doc;
        }
      }
    });

    return options.returnDocument ? { data, documents } : data;
  } catch (error) {
    console.error("Error updating DOM component:", error);
    throw error;
  }
}

export function showToast(message, type = "info", duration = 3000) {
  const container = document.getElementById("toast-container");
  if (!container) {
    return null;
  }

  const toast = document.createElement("div");
  toast.className = "alert shadow-lg mb-2 animate-fade-in";

  const typeClasses = {
    success: "alert-success",
    error: "alert-error",
    warning: "alert-warning",
    info: "alert-info",
  };

  if (typeClasses[type]) {
    toast.classList.add(typeClasses[type]);
  }

  const icons = {
    success:
      '<svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
    error:
      '<svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
    warning:
      '<svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>',
    info: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>',
  };

  toast.innerHTML = `
        <div class="flex items-center gap-2">
          ${icons[type] || icons.info}
          <span></span>
        </div>
      `;

  const messageNode = toast.querySelector("span");
  if (messageNode) {
    messageNode.textContent = String(message);
  }

  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transform = "translateX(100%)";
    toast.style.transition = "all 0.3s ease-out";

    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }, duration);

  return toast;
}

export function initEmblaProgress(carousel, emblaApi) {
  const progressTrack = carousel.querySelector(".progress-track");
  const progressFill = progressTrack?.querySelector(".progress-fill");

  const applyProgress = () => {
    if (!progressTrack || !progressFill) return;
    const total = emblaApi.scrollSnapList().length;
    const canScroll =
      total > 1 && (emblaApi.canScrollPrev() || emblaApi.canScrollNext());
    progressTrack.hidden = !canScroll;
    if (!canScroll) return;

    const selected = emblaApi.selectedScrollSnap();
    const segment = 100 / total;
    progressFill.style.width = `${segment}%`;
    // translate percent is relative to the fill width, so use selected * 100%
    progressFill.style.transform = `translateX(${selected * 100}%)`;
  };

  let raf = 0;
  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      applyProgress();
    });
  };

  emblaApi.on("scroll", onScroll);
  emblaApi.on("reInit", applyProgress);
  emblaApi.on("resize", applyProgress);
  applyProgress();
}

function initTheme() {
  initScrollChecker();
  setHeaderFooterHeight();
  setFooterActions();
  setDrawerListeners();
  checkForExitPopup();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTheme, { once: true });
} else {
  initTheme();
}

function setDrawerListeners() {

  document.addEventListener('change', (e) => {
    // Verifichiamo se l'elemento è un toggle di DaisyUI
    if (e.target.classList.contains('drawer-toggle')) {
      
      // Se il drawer corrente viene aperto, chiudiamo tutti gli altri
      if (e.target.checked) {
        document.querySelectorAll('.drawer-toggle').forEach((input) => {
          if (input !== e.target) {
            input.checked = false;
          }
        });
      }

      const header = document.querySelector('header');

      // Controlliamo se almeno un drawer è aperto
      const anyDrawerOpen = Array.from(document.querySelectorAll('.drawer-toggle'))
        .some(input => input.checked);

      if (anyDrawerOpen) {
        document.body.classList.add('drawer-active');
        header?.classList.add('is-open'); // Esempio: nascondi header
      } else {
        document.body.classList.remove('drawer-active');
        header?.classList.remove('is-open');
      }
    }
  });
}

function setFooterActions() {
  document
  .querySelectorAll('input[name="footer-links')
  .forEach((input) => {
    input.addEventListener('change', (event) => {
      if (event.target.checked) {
        console.log('Accordion aperto:', event.target, footer.offsetHeight);
        setHeaderFooterHeight();
      }
    });
  });
}

function checkForExitPopup() {
  const isHomepage = document.body.classList.contains('template-index');


    setTimeout(function() {
      if (isHomepage) {
          const cartStatus = localStorage.getItem('justAddedToCart');

          if (cartStatus) {
              const cartData = JSON.parse(cartStatus);

              if (cartData.added) {
                  document.getElementById("exit-dialog")?.showModal();
                  localStorage.removeItem('justAddedToCart');
              }
          }
      }
    }, 2500);
}